export default {
  PAGE_TYPE: 'Passengers',
  PAGE_NAME_TOW_RIDERS: 'Tow Riders',
  DISMISS: 'Passengers Dismiss',
}
